/** TrackHub-hosted bag sticker URL; optional ?print=1 opens the browser print dialog. */
export function shipmentLabelHref(rawUrl, { print = false } = {}) {
  const raw = String(rawUrl || "").trim();
  if (!raw) return "";
  try {
    const url = new URL(raw);
    if (print) {
      url.searchParams.set("print", "1");
    } else {
      url.searchParams.delete("print");
    }
    return url.toString();
  } catch {
    return raw;
  }
}
